import { isTokenExpired, fetchTokenData } from "../../../utils/auth/auth";
import { RestService } from "../../../components/generic";
import ensureTrailingSlash from "../../../utils/url/url";
import TOKEN_TYPES from "../../../constants/tokenTypes";

export const User = Object.freeze({
  USER_SIGN_IN: "USER_SIGN_IN",
  USER_SIGN_OUT: "USER_SIGN_OUT",
  SET_SESSION_ID: "USER_SET_SESSION_ID",
  SET_TOKEN_DATA: "USER_SET_TOKEN_DATA",
  UPDATE_USER_DATA: "UPDATE_USER_DATA",
});

export const setTokenData = tokenData => ({
  type: User.SET_TOKEN_DATA,
  payload: tokenData,
});

// -- ACTIONS --
export const getRefreshedToken = tokenType => async (dispatch, getState) => {
  // get current token data
  const { tokenData } = getState().user;

  // check if expired
  if (isTokenExpired(tokenData)) {
    console.log("Token was EXPIRED, refreshing");

    // refresh token data
    const { sessionId } = getState().user;
    const result = await fetchTokenData(sessionId);
    dispatch(setTokenData(result));

    // return token
    if (!tokenType) {
      return { accessToken: result.accessToken, idToken: result.idToken };
    }
    return Promise.resolve(
      tokenType === TOKEN_TYPES.idToken
        ? { idToken: result.idToken }
        : { accessToken: result.accessToken }
    );
  }

  // return token directly since it is still valid
  if (!tokenType) {
    return { accessToken: tokenData.accessToken, idToken: tokenData.idToken };
  }
  return Promise.resolve(
    tokenType === TOKEN_TYPES.idToken
      ? { idToken: tokenData.idToken }
      : { accessToken: tokenData.accessToken }
  );
};

export const setSessionId = sessionId => ({
  type: User.SET_SESSION_ID,
  payload: sessionId,
});

export const userSignOut = () => ({
  type: User.USER_SIGN_OUT,
  payload: { analytics: {} },
});

export const userSignIn = signInData => ({
  type: User.USER_SIGN_IN,
  payload: {
    signInData,
    analytics: {
      signInData,
    },
  },
});

export const updateUserData = userData => ({
  type: User.UPDATE_USER_DATA,
  payload: userData,
});

// eslint-disable-next-line consistent-return
export const fetchUserDataFromOrigo = userId => async (dispatch, getState) => {
  const origoBaseUrl = ensureTrailingSlash(process.env.REACT_APP_ORIGO_URL);
  const userDataApi = ensureTrailingSlash(
    process.env.REACT_APP_ORIGO_USER_DATA_API
  );
  const path = `${origoBaseUrl}api/v1/${userDataApi}${userId}`;
  try {
    const { tokenData } = getState().user;
    const config = RestService.createConfig(tokenData.accessToken);
    const origoUserData = await RestService.get(path, config);
    dispatch(
      updateUserData({
        phoneNumber: origoUserData.phoneNumber,
        language: origoUserData.language,
      })
    );
    return origoUserData;
  } catch (error) {
    // TODO: error handling
    console.error(error);
  }
};

// -- REDUCER --

const INIT_STATE = {
  userData: {},
  signedIn: false,
  sessionId: null,
  tokenData: null,
};

// eslint-disable-next-line default-param-last
export const userReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case User.SET_SESSION_ID:
      return { ...state, sessionId: action.payload };
    case User.SET_TOKEN_DATA:
      return { ...state, tokenData: action.payload };
    case User.USER_SIGN_OUT:
      return {
        ...state,
        signedIn: false,
        sessionId: null,
        tokenData: null,
        userData: null,
      };
    case User.USER_SIGN_IN: {
      const { sessionId, userData, tokenData } = action.payload.signInData;
      return { ...state, sessionId, userData, tokenData, signedIn: true };
    }
    case User.UPDATE_USER_DATA:
      return { ...state, userData: { ...state.userData, ...action.payload } };
    default:
      return state;
  }
};
